import {Modal} from "antd";


export const UndoHarvestModal = ({open, onOk, onCancel, props}) => {

    const onModalOk = () => {
        if (onOk) {
            onOk();
        }
    }

    const onModalCancel = () => {
        if (onCancel) onCancel();
    }

    return <Modal title={<b>Undo Harvest</b>} open={open} onOk={onModalOk} onCancel={onModalCancel}>
        <div>Plants will be Returned to Harvest Room</div>
    </Modal>
}